export const BASE_ROUTE_ADMIN = 'admin';
export const BASE_ROUTE_USER = 'user';
